export enum FacilityType {
  BRANCH = 'branch',
  MAIN = 'main',
}
